import React, { useEffect, useState } from "react";
import Base from '../../utils/base'
import moment from "moment";

export default function Gallery(props) {
  var base = new Base()
  const momentNow = moment()
  const [arr, setArr] = useState([])

  useEffect(() => {
    get_data()
  }, [])
  
  async function get_data() {
    var response = await base.request(base.url_api + "/gallery")

    if(response != null){
      if(response.status == "success"){
        for(let data of response.data){
          data.image = data.url_image
        }
        setArr(response.data)
      }
      else
        base.show_error(response.message)
    }
    else
      console.log('Server Error')
  }

  return (
    <section className="gallery-one gallery-one--page">
      <div className="container">
        <div className="row masonry-layout">
          {
            arr.map((data, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div className="gallery-one__card">
                  <img src={data.image} alt="" />
                  <div className="gallery-one__card__hover">
                    <a href={data.image} className="img-popup">
                      <div className="gallery-one__card__icon">
                        <span className="gallery-one__card__icon__item"></span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </section>
  );
};
